
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"7.692","fill":"#FAE6CB"}}),_c('path',{attrs:{"d":"M23.685 10.797c-.936-1.01-2.243-1.566-3.685-1.566-1.45 0-2.761.553-3.692 1.557-.942 1.015-1.4 2.394-1.293 3.883.214 2.939 2.45 5.33 4.985 5.33s4.767-2.39 4.984-5.329c.11-1.476-.352-2.852-1.3-3.875zM28.462 30.77H11.539a1.49 1.49 0 01-1.164-.536c-.313-.373-.438-.883-.345-1.4.406-2.25 1.672-4.141 3.662-5.468 1.769-1.179 4.009-1.827 6.308-1.827 2.3 0 4.54.649 6.308 1.826 1.99 1.327 3.256 3.218 3.662 5.47.094.515-.032 1.025-.345 1.399a1.49 1.49 0 01-1.163.535z","fill":"#F69F27"}})])
          )
        }
      }
    